// client/entity-picker-utils.ts
import { subscribeByID } from "@adornis/baseql/operations/mongo.js";
import { subscribePaginatedAndFiltered } from "@adornis/filter/db/subscribePaginatedAndFiltered.js";
import { getStandardFilterOperation } from "@adornis/filter/get-standard-filter-operation.js";
import {
  combineLatest,
  debounceTime,
  distinctUntilChanged,
  firstValueFrom,
  of,
  switchMap,
  timer
} from "rxjs";
var subscibeEntityByEntityPickerValue = (options$, value$) => combineLatest([options$, value$]).pipe(
  // * If you select a value options$ and value$ will be emitted nearly at the same time,
  // * resulting in a few useless calls. We debounce here to prevent that and just take the latest.
  // * 5ms won't be noticeable for the user, but it will prevent the useless calls.
  debounceTime(5),
  // * Only $value, $options.class and $options.selectionSet are relevant for the subscription,
  // * so we only emit if they actually changed.
  distinctUntilChanged((prev, curr) => {
    const [prevOptions, prevValue] = prev;
    const [currOptions, currValue] = curr;
    return (prevValue === currValue || prevValue === null && currValue === void 0 || prevValue === void 0 && currValue === null) && prevOptions?.class === currOptions?.class && JSON.stringify(prevOptions?.selectionSet) === JSON.stringify(currOptions?.selectionSet);
  }),
  switchMap(([options, value]) => {
    const clonedSelectionSet = JSON.parse(JSON.stringify(options?.selectionSet ?? {}));
    return options ? subscribeByID(options.class, value ?? "")(clonedSelectionSet) : of(null);
  })
);
var subscibeEntitiesByEntityPickerValue = (options$, value$) => combineLatest([options$, value$]).pipe(
  distinctUntilChanged((prev, curr) => prev[1]?.length === curr[1]?.length),
  switchMap(([options, value]) => {
    return options && value?.length ? subscribeByID(options.class, value)(options?.selectionSet ?? {}) : of([]);
  })
);
var entityPickerSearch = (options) => async (search, InstanceType) => {
  await firstValueFrom(timer(100));
  if (!options)
    throw new Error("No options given");
  let subscription = options.operation;
  if (!subscription) {
    if (!options.class)
      throw new Error("No operation and no class given");
    subscription = getStandardFilterOperation(options.class, subscribePaginatedAndFiltered);
  }
  const filter = options?.filter;
  if (!filter) {
    throw new Error("No filter given");
  }
  filter.search = search === InstanceType.renderSelected(InstanceType.value.value) ? null : search ?? null;
  return firstValueFrom(
    subscription(0, options.limit ?? 20, filter)(options.selectionSet ?? {})
  );
};
export {
  entityPickerSearch,
  subscibeEntitiesByEntityPickerValue,
  subscibeEntityByEntityPickerValue
};
